import "../DatePicker.css";
import Picker from "react-datepicker";
import DateHeader from "../DateHeader/DateHeader";
import { Container, weekDayMap } from "../helpers";
import { CalendarTheme } from "../enum";

type CalendarDatePickerProps = {
  date?: Date;
  setDate: (date: Date) => void;
  highlightDates?: Date[];
  theme?: CalendarTheme;
  minDate?: Date;
  maxDate?: Date;
  disableSelect?: boolean;
  onMonthChange?: (date: Date) => void;
};

export const CalendarDatePicker = ({
  theme = CalendarTheme.Primary,
  date,
  setDate,
  highlightDates,
  minDate,
  maxDate,
  disableSelect = false,
  onMonthChange,
}: CalendarDatePickerProps) => {
  const handleChange = (date: Date) => {
    setDate(date);
  };
  return (
    <div data-testid="calendar-date-picker">
      <Picker
        selected={date}
        minDate={minDate}
        maxDate={maxDate}
        calendarClassName={CalendarTheme[theme].toLowerCase()}
        calendarContainer={Container}
        highlightDates={highlightDates}
        renderCustomHeader={DateHeader(false, minDate, maxDate, date)}
        onChange={handleChange}
        onMonthChange={(date) => onMonthChange?.(date)}
        formatWeekDay={(day) => <div>{weekDayMap[day]}</div>}
        inline
        disabledKeyboardNavigation={disableSelect}
        enableTabLoop={false}
        calendarStartDay={1}
      />
    </div>
  );
};
